export default __webpack_public_path__ + "static/media/more.f571d4a8.png";